import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';

import { SecurityDefinition } from './security.service';

@Injectable()
export class CryptoService {

    /** 
     * @name getKey 
     * @description Retourne la clé XOR 
     * @return {string} clefXOR Clé XOR 
     */
    public getKey(): string {
        let clefXOR = '%%clef.xor%%';
        // si la compilation Gulp n'a pas remplacé le token 
        if (clefXOR.indexOf('%') >= 0) {
            // affectation statique pratique en mode dev 
            clefXOR = '09E47D5F12AC4DE57D1A3DFE6E90A1CC';
        }

        return clefXOR;
    }

    /**
     * @name getSalt
     * @description Retourne un salt
     * @param {number} nbNyte Le nombre d'octet du salt
     */
    public getSalt(nbByte: number): CryptoJS.lib.WordArray {
        return CryptoJS.lib.WordArray.random(nbByte);
    }

    /**
     * @name encode
     * @description Encode une chaine
     * @param {string} text Le texte a encoder
     * @param {SecurityDefintion} config Les options d'encodage
     */
    public encode(text: string, config: SecurityDefinition, salt?: string): string {
        // si null ou undefined peu probable en TS, mais 0 possible !
        if ( config.nb_iteration === undefined || config.nb_iteration === null )
            config.nb_iteration = 1;


        // let encoded: CryptoJS.lib.WordArray = null;
        let encoded = CryptoJS.enc.Utf8.parse(text);
        // let encoded = text;
        let encoderMethod = null;

        switch (config.method.toLowerCase()) {
            case "md5":
                encoderMethod = CryptoJS.MD5;
                break;
            case "sha1":
                encoderMethod = CryptoJS.SHA1;
                break;
            case "sha256":
                encoderMethod = CryptoJS.SHA256;
                break;
            case "sha512":
                encoderMethod = CryptoJS.SHA512;
                break;
        }

        if (encoderMethod === null)
            return null;

        for (let i = 0; i < config.nb_iteration; i++) {
            if (salt) {
                encoded = encoderMethod(encoded + salt);
            } else {
                encoded = encoderMethod(encoded);
            }
        }

        if (config.base64) {
            return encoded.toString(CryptoJS.enc.Base64);
        }

        return encoded.toString();
    }

    /**
     * Revert encode function call (only possible if 0 hashing iterations occurred)
     * @param {string} text : output from encode function call when 0 iterations were used
     * @param {SecurityDefintion} config : the same encoding options as in encode function call
     */
    public decode(text :string, config: SecurityDefinition){
        let decoded = ( config.base64 ) ? CryptoJS.enc.Base64.parse(text) : CryptoJS.enc.Hex.parse(text);
        return CryptoJS.enc.Utf8.stringify(decoded);
    }

    private urlsafe_b64decode(b64str) {
        let data = b64str.replace(/-/g, '+');
        data = data.replace(/_/g, '/');
        data = data.replace(/\./g, '=');

        let mod4 = data.length % 4;

        if (mod4) {
            data += data.substr(data.indexOf('===='), mod4);
        }

        let parsedWordArray = CryptoJS.enc.Base64.parse(data);
        let parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8);

        return parsedStr;
    };

    private urlsafe_b64encode(str) {
        let words = CryptoJS.enc.Utf8.parse(str); // WordArray object
        let base64 = CryptoJS.enc.Base64.stringify(words); // string: 'SGVsbG8gd29ybGQ='

        return base64;
    };

    private XOREncryption(str, keyPhrase) {
        let keyPhraseLength = keyPhrase.length;
        let strLength = str.length;
        let i;
        let result = [];

        for (i = 0; i < strLength; i++) {
            let rPos = i % keyPhraseLength;
            let r = str.charAt(i).charCodeAt(0) ^ keyPhrase.charAt(rPos).charCodeAt(0);
            result[i] = String.fromCharCode(r);
        }

        return result.join('');
    };

    public XOREncrypt(str, keyPhrase) {
        let result = this.XOREncryption(str, keyPhrase);
        result = this.urlsafe_b64encode(result);

        return result;
    };

    public XORDecrypt(str, keyPhrase) {
        let result = this.urlsafe_b64decode(str);
        result = this.XOREncryption(result, keyPhrase);

        return result;
    };


}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/services/crypto.service.ts